<template>
  <div class="Ldr-Circle-Wrapper" :style="get_size">
    <LoaderCircle :color="props.color" :size="props.size" />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { Props } from './scripts/props.js';
  //--------------------------
  import LoaderCircle from '../LoaderCircle/LoaderCircle.vue';
  //--------------------------
  const props = defineProps(Props());
  //--------------------------
  //Получаем размер лоадера
  const get_size = computed(() => `
    max-width: ${props.size * 2}px;
    max-height: ${props.size * 2}px;
    min-width: ${props.size * 2}px;
    min-height: ${props.size * 2}px;
  `);
</script>

<style scoped lang="scss">
  @import './styles/_styles';
</style>